import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Button,
  Card,
  CardHeader,
  Container,
  Row,
  Col,
  FormGroup,
  Input,
} from "reactstrap";
import "../../assets/css/custom.css";
import Header from "components/Headers/Header.js";
import { clientmanageService } from "../../services/clientmanageService.js";
import { ToastContainer, toast } from "react-toastify";
import Select from "react-select";

const AddSmeTransitionV2 = () => {
  const history = useHistory();
  const [clientList, setClientList] = useState([]);
  const [subClientList, setSubClientList] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedSubClient, setSelectedSubClient] = useState(null);
  const [transitionDate, setTransitionDate] = useState("");
  const [disableState, setDisableState] = useState(false);

  useEffect(() => {
    loadClients();
  }, []);

  function loadClients() {
    clientmanageService.getuniqueclientforsme().then((response) => {
      if (response && response.status === 200) {
        setClientList(response.data.client || []);
      }
    });
  }

  function onClientChange(e) {
    setSelectedClient(e);
    setSelectedSubClient(null);
    setSubClientList([]);

    if (e && e.label) {
      clientmanageService.getsubclientlist(e.label).then((response) => {
        if (response && response.status === 200) {
          const options = response.data.map((item) => ({
            value: item.id,
            label: item.sub_client,
          }));
          setSubClientList(options);
        }
      });
    }
  }

  function handleSubmit(e) {
    e.preventDefault();

    if (!selectedSubClient) {
      toast.error("Please select a sub client");
      return;
    }
    if (!transitionDate) {
      toast.error("Please select a transition date");
      return;
    }

    setDisableState(true);

    clientmanageService
      .addTransitionV2({
        sub_client_id: selectedSubClient.value,
        transition_date: transitionDate,
      })
      .then((response) => {
        if (response && response.status === 200) {
          toast.success(response.data.message);
          setTimeout(() => {
            history.push("/admin/sme-transition-v2");
          }, 1000);
        } else if (response && response.data && response.data.message) {
          toast.error(response.data.message);
        } else {
          toast.error("Something went wrong!");
        }
        setDisableState(false);
      });
  }

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row className="mt-5">
          <div className="col" style={{ padding: "0%" }}>
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <Col xl="6">
                    <h3 className="mb-0">Add Transition</h3>
                  </Col>
                  <Col xl="6" style={{ textAlign: "right" }}>
                    <Button
                      color="secondary"
                      type="button"
                      onClick={() =>
                        history.push("/admin/sme-transition-v2")
                      }
                    >
                      Back to List
                    </Button>
                  </Col>
                </Row>
              </CardHeader>
              <div style={{ padding: "20px" }}>
                <Row>
                  <Col xl="4">
                    <FormGroup>
                      <label className="form-control-label">Client</label>
                      <Select
                        className="input-group-alternative mb-3"
                        name="client_id"
                        options={clientList}
                        onChange={onClientChange}
                        value={selectedClient}
                        placeholder="Select Client"
                        isClearable={false}
                      />
                    </FormGroup>
                  </Col>
                  <Col xl="4">
                    <FormGroup>
                      <label className="form-control-label">Sub Client</label>
                      <Select
                        className="input-group-alternative mb-3"
                        name="sub_client_id"
                        options={subClientList}
                        onChange={(e) => setSelectedSubClient(e)}
                        value={selectedSubClient}
                        placeholder="Select Sub Client"
                        isClearable={false}
                        isDisabled={!selectedClient}
                      />
                    </FormGroup>
                  </Col>
                  <Col xl="4">
                    <FormGroup>
                      <label className="form-control-label">
                        Transition Date
                      </label>
                      <Input
                        type="date"
                        value={transitionDate}
                        onChange={(e) => setTransitionDate(e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button
                      color="primary"
                      type="button"
                      onClick={handleSubmit}
                      disabled={disableState}
                    >
                      {disableState ? "Submitting..." : "Submit"}
                    </Button>
                  </Col>
                </Row>
              </div>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default AddSmeTransitionV2;
